import { Injectable } from '@angular/core';
import { BreadcrumbItem } from '../../components/breadcrumbs/breadcrumbs.component';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {

  private _breadcrumbHeap: BreadcrumbItem[] = [];

  constructor() {
    // TODO: intercettare gli eventi di "back" del browser per aggiornare dinamicamente l'heap richiamando il metodo "popUrl()"
  }

  get breadcrumbHeap(): BreadcrumbItem[] {
    return this._breadcrumbHeap;
  }
  
  getLast():BreadcrumbItem{
    return this._breadcrumbHeap[0];
  }

  /**
   * Aggiunge al primo elemento dell'heap delle url la url fornita in input
   * @param breadcrumbItem la url da sostituire al primo elemento dell'heap muovendo gli altri elementi
   */
  public pushUrl(breadcrumbItem: BreadcrumbItem): BreadcrumbItem[] {
    if (this.isSegmentPresent(breadcrumbItem) === false) {
      this._breadcrumbHeap.unshift(breadcrumbItem);
    } else {
      this.popUrl();
      this._breadcrumbHeap.unshift(breadcrumbItem);
    }
    return this._breadcrumbHeap;
  }

  public isSegmentPresent(breadcrumbItem: BreadcrumbItem): boolean {
    // Estrai la parte tra '/' e '?' dal routerLink del nuovo elemento
    const newItemSubstring = breadcrumbItem.routerLink.split('?')[0];

    // Controlla se c'è già un elemento con una parte simile presente nell'heap
    const existingIndex = this._breadcrumbHeap.findIndex(item => {
      // Estrai la parte tra '/' e '?' dal routerLink dell'elemento corrente
      const currentItemSubstring = item.routerLink.split('?')[0];
      // Confronta le parti estratte
      return newItemSubstring === currentItemSubstring;
    });

    if (existingIndex > -1) {
      return true
    } else {
      return false
    }

  }

  /**
   * Rimuove solo il primo elemento dell'heap.
   */
  public popUrl(): BreadcrumbItem[] {
    this._breadcrumbHeap.shift();

    return this._breadcrumbHeap;
  }

  /**
   * Rimuove dall'heap N livelli di navigazione specificati nel parametro di input.
   * Ad esempio, se l'heap è composto da ['risultati','dettaglio','download'] e specifico
   * levelsToRemove = 2, l'heap risultante sarà composto solo da un elemento ['risultati']
   * @param levelsToRemove
   */
  public removeNavigationLevels(levelsToRemove: number): BreadcrumbItem[] {
    this._breadcrumbHeap = this._breadcrumbHeap.slice(levelsToRemove, this._breadcrumbHeap.length)

    return this._breadcrumbHeap;
  }

  public emptyBreadcrumbs(): void {
    this._breadcrumbHeap = [];
  }

}
